import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { ArrowRight, Sparkles } from 'lucide-react'

export default function CTASection() {
    return (
        <section className="py-24 relative overflow-hidden">
            {/* Animated background */}
            <div className="absolute inset-0">
                <motion.div
                    className="absolute top-0 left-1/4 w-96 h-96 bg-primary-blue/20 rounded-full blur-3xl"
                    animate={{
                        scale: [1, 1.2, 1],
                        opacity: [0.3, 0.5, 0.3],
                    }}
                    transition={{ duration: 8, repeat: Infinity }}
                />
                <motion.div
                    className="absolute bottom-0 right-1/4 w-96 h-96 bg-accent-gold/20 rounded-full blur-3xl"
                    animate={{
                        scale: [1.2, 1, 1.2],
                        opacity: [0.2, 0.4, 0.2],
                    }}
                    transition={{ duration: 10, repeat: Infinity }}
                />
            </div>

            <div className="container mx-auto px-4 relative z-10">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="max-w-4xl mx-auto text-center"
                >
                    {/* Icon */}
                    <motion.div
                        initial={{ scale: 0 }}
                        whileInView={{ scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, type: 'spring' }}
                        className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-primary-blue to-accent-gold mb-8 glow-primary"
                    >
                        <Sparkles className="h-8 w-8 text-white" />
                    </motion.div>

                    {/* Heading */}
                    <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-theme-primary mb-6">
                        Ready to Transform Your
                        <span className="block mt-2 gradient-text text-luxury">
                            NEET Journey?
                        </span>
                    </h2>

                    {/* Description */}
                    <p className="text-lg md:text-xl text-theme-secondary mb-10 max-w-2xl mx-auto">
                        Join thousands of successful students who chose Future Founder for their
                        NEET preparation. Start your journey to medical college today.
                    </p>

                    {/* CTA Buttons */}
                    <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                        <Link
                            to="/courses"
                            className="group px-10 py-4 bg-primary-blue hover:bg-blue-600 text-white font-semibold rounded-lg glow-primary hover:scale-105 transition-all duration-300 flex items-center gap-2"
                        >
                            Get Started Now
                            <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
                        </Link>
                        <Link
                            to="/contact"
                            className="px-10 py-4 bg-slate-200 dark:bg-slate-800/50 hover:bg-slate-300 dark:hover:bg-slate-800/80 text-theme-primary font-semibold rounded-lg hover:scale-105 transition-all duration-300"
                        >
                            Talk to an Expert
                        </Link>
                    </div>

                    {/* Trust indicators */}
                    <div className="mt-12 pt-8 border-t border-slate-300 dark:border-slate-700/50">
                        <p className="text-sm text-theme-muted mb-4">Trusted by students from</p>
                        <div className="flex flex-wrap justify-center items-center gap-8 opacity-60">
                            <div className="text-theme-muted font-semibold">IIT Coaching Centers</div>
                            <div className="text-theme-muted font-semibold">Top Schools</div>
                            <div className="text-theme-muted font-semibold">Leading Academies</div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    )
}
